import { render } from "./TvmCurrentVehicle.vue?vue&type=template&id=58289752&scoped=true"
import script from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"
export * from "./TvmCurrentVehicle.vue?vue&type=script&lang=js"

import "./TvmCurrentVehicle.vue?vue&type=style&index=0&id=58289752&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58289752"]])

export default __exports__